﻿var vm;

(function () {
    'use strict';
    var controllerId = 'appointmentQRCtrl';
    angular
        .module('app.controllers')
        .controller(controllerId, appointmentQRCtrl);

    appointmentQRCtrl.$inject = ['common', 'datacontext', '$http', '$scope', '$stateParams'];
    
    function appointmentQRCtrl(common, datacontext, $http, $scope, $stateParams) {

        vm = this;
        vm.idap = '';
        vm.cita = '';
        vm.fecha = '';
        vm.hora = '';

        init();
        getAppointmentById($stateParams.idap);       

        function init() {
            var divElement = angular.element(document.querySelector('#header'));
            divElement.remove();
            common.activateController([])
                .then(function (data) {

                });
        }

        function getAppointmentById(appointmentId) {
            return datacontext.appointment.getAppointmentById(appointmentId).then(function (data) {                

                if (data) {
                  
                    var Alpha;
                    vm.citaId = data.Appointment.AppointmentId;
                    vm.citaNo = data.Appointment.AppointmentNo;
                    Alpha = data.Appointment.AppointmentDate;
                    Alpha = new Date(Alpha);
                    var hours = Alpha.getHours();
                    var minutes = Alpha.getMinutes();
                    var ampm = hours >= 12 ? 'PM' : 'AM';
                    hours = hours % 12;
                    hours = hours ? hours : 12; // the hour '0' should be '12'
                    minutes = minutes < 10 ? '0' + minutes : minutes;
                    var HourString = hours + ':' + minutes + ' ' + ampm;

                    var DateString = ("0" + (Alpha.getMonth() + 1)).slice(-2) + "/" + ("0" + Alpha.getDate()).slice(-2) + "/" + Alpha.getFullYear();
                    vm.fecha = DateString;
                    vm.hora = HourString;
                    vm.patio = data.Appointment.YardName;
                }                

            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        }      

    }    
})();